module.exports = __webpack_public_path__ + "img/real-time.2945831c.svg";